import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDatetime } from '../../utils/dateUtils';

//css
import './DigitalPriceTag.css';

//Ui
import Button from '../../components/button';
import CustomPaginationTable from '../../components/table/CustomPaginationTable';

//components
import LogPreviewForm from './LogPreviewForm';

// Redux actions
import { fetchDigitalPriceListExcel } from '../../redux/digitalPriceExcelSlice';

function ExcelUploadLog() {
  const dispatch = useDispatch();
  const {
    content: excelLogs,
    pageNumber: currentPage,
    totalRecords: totalRows,
    totalPages,
    loading,
    error
  } = useSelector((state) => state.digitalPriceExcel);

  const [perPage, setPerPage] = useState(10);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  const getDiscountTypeLabel = (type) => {
    switch (type) {
      case '1': return 'Roadshow';
      case '2': return 'Chainwide';
      case '3': return 'Selected Shop';
      default: return type;
    }
  };

  const columns = [
    {
      name: <div>Record ID</div>,
      cell: (row, index) => (
        <>
          <div>{row.excelRecordId}</div>
        </>
      ),
    },
    {
      name: <div>File Name</div>,
      cell: (row, index) => (
        <>
          <div>{row.fileSourceOriginal}</div>
        </>
      ),
    },
    {
      name: <div>Uploaded Date Time</div>,
      cell: (row, index) => (
        <>
          <div>{formatDatetime(row.createdDatetime)}</div>
        </>
      ),
    },
    {
      name: <div>Uploaded By</div>,
      cell: (row, index) => (
        <>
          <div>{row.createdBy}</div>
        </>
      ),
    },
    {
      name: <div>SKU Count</div>,
      cell: (row, index) => (
        <>
          <div>{row.messageText}</div>
        </>
      ),
    },
    {
      name: <div>Excel Upload Type</div>,
      cell: (row, index) => <div>{getDiscountTypeLabel(row.discountType)}</div>,
    },
    {
      name: 'Action',
      cell: (row, index) => (
        <>
          <div><Button className='preview-btn' onClick={(e) => handlePreviewClick(row, index)}>Preview</Button></div>
        </>
      ),
    }
  ];

  useEffect(() => {
    dispatch(fetchDigitalPriceListExcel({ page: 0, size: perPage }));
  }, [dispatch]);

  const handlePageChange = (page) => {
    dispatch(fetchDigitalPriceListExcel({ page: page - 1, size: perPage }));
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    dispatch(fetchDigitalPriceListExcel({ page: page - 1, size: newPerPage }));
  };

  const handlePreviewClick = (row, index) => {
    setIsPreviewOpen(true);
    setPreviewData(row);
  };

  const handleCancel = () => {
    setIsPreviewOpen(false);
  };

  return (
    <div className="manage-user-container">
      {!isPreviewOpen && (
        <div style={{ padding: '30px' }}>
          Excel Upload Log

          <div style={{ marginTop: '20px' }}>
            <CustomPaginationTable
              columns={columns}
              data={excelLogs}
              totalRows={totalRows}
              loading={loading}
              perPage={perPage}
              currentPage={currentPage + 1} // Adding 1 because API uses 0-based index
              onPageChange={handlePageChange}
              onPerRowsChange={handlePerRowsChange}
            />
          </div>
        </div>
      )}

      {isPreviewOpen && previewData && (
        <LogPreviewForm
          title={'Excel Upload Log'}
          previewData={previewData}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
}

export default ExcelUploadLog;